import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnLineItemsEmailRenderer } from "./email";
import type { ReturnLineItemsBlockProps } from "./types";

export function ReturnLineItemsEditorRenderer(props: ReturnLineItemsBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnLineItemsEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
